
import Vue from 'vue'

export default Vue.extend({
  name: 'lastCallToSupportTopic',
  props: {
    value: {
      type: String,
      required: true
    }
  }
})
